import { Link, useLocation } from "react-router-dom";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="max-w-3xl mx-auto w-full px-4 md:px-6 py-20 md:py-28 text-center">
      <Seo
        title="页面不存在 - 51爆料"
        description="抱歉，你访问的页面不存在或已被移除。"
      />
      <p className="text-6xl md:text-8xl font-heading font-black text-primary-500">
        404
      </p>
      <h1 className="mt-4 text-xl md:text-2xl font-heading font-black text-foreground-950">
        这个页面还没有被生成
      </h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono break-all">
        {location.pathname}
      </p>
      <p className="mt-4 text-sm text-foreground-600">
        页面可能已被移动或删除，去首页看看最新的爆料吧。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="px-5 py-2.5 rounded-md border border-background-300 hover:border-primary-400 text-sm text-foreground-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览全部爆料
        </Link>
      </div>
    </div>
  );
}